/** Where a signed-in person lands, by role (GET /api/me). Pure. */
import type { Me } from './schemas'

export type Home =
  | { kind: 'admin' }
  | { kind: 'founder'; founderId: string }
  | { kind: 'viewer' }
  /** A founder or teammate with no founder attached: nothing to set up yet. */
  | { kind: 'unlinked' }

export function homeFor(me: Pick<Me, 'person'>): Home {
  const p = me.person
  if (p.role === 'admin') return { kind: 'admin' }
  if (p.role === 'viewer') return { kind: 'viewer' }
  return p.founderId ? { kind: 'founder', founderId: p.founderId } : { kind: 'unlinked' }
}

/** A founder's front door: their setup until it's complete, then their dashboard. */
export function founderLanding(setupComplete: boolean): '/setup' | '/home' {
  return setupComplete ? '/home' : '/setup'
}
